import { DollarSign } from 'lucide-react'
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { useCurrencyStore, CURRENCIES } from '@/stores/useCurrencyStore'

export function CurrencySelector() {
  const currency = useCurrencyStore((s) => s.currency)
  const setCurrency = useCurrencyStore((s) => s.setCurrency)
  const active = CURRENCIES.find((c) => c.code === currency) ?? CURRENCIES[0]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="gap-1 text-xs hidden sm:flex h-8 rounded-full px-2"
          aria-label="Devise"
        >
          <DollarSign className="h-3.5 w-3.5" />
          <span className="hidden lg:inline tabular-nums">{active.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Devise d'affichage</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {CURRENCIES.map((c) => (
          <DropdownMenuItem
            key={c.code}
            onClick={() => setCurrency(c.code)}
            className="flex items-center justify-between gap-2 text-xs"
          >
            <span>{c.label}</span>
            <span className="text-muted-foreground tabular-nums">{c.symbol} {c.code}</span>
            {c.code === currency && <span className="text-primary">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
